export default __webpack_public_path__ + "static/media/new-logo.7c39f821.png";